export enum StatusyWeryfikacjiZgodnosciZOryginalem {
  NieSprawdzono = 1,
  ZgodnyZOryginalem,
  NieZgodnyZOryginalem,
}
